/* eslint-disable prettier/prettier */
import React, { useContext } from "react";
import { RACAlert } from "@rentacenter/racstrap";
import { reversePaymentStyle } from "../../stylesJS/reversePaymentStyle";
import { GeneralStateContext } from "../../context/GeneralProvider";
import { useTranslation } from 'react-i18next';

export default function ReverseException() {
  const { t } = useTranslation("translation")
  const classes = reversePaymentStyle();
  const { isSIMSReceipt } = useContext(GeneralStateContext);
  return (
    <RACAlert
      AlertMessage={
        t("This payment is taken in SIMS. Please reverse your payment in SIMS.")
      }
      variant="outlined"
      severity="error"
      className={
        isSIMSReceipt ? `${classes.alertBackground}` : `${classes.hideAlert}`
      }
    />
  );
}// This component will be rendering the exception card when the receipt is from SIMS.
